export default __webpack_public_path__ + "static/media/logo_orange.f394b4f2.png";